// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../../../common/JQueryView';
import dayjs from 'dayjs';
import DateRangePicker from '../../../../../common/DateRangePicker';

export default class FormView extends JQueryView {
  establishAt: string;
  isUser: boolean;

  constructor(isUser: boolean, establishAt: string) {
    super('.rightholders-wrapper');
    this.establishAt = establishAt;
    this.initDateRangePicker(this.$el);
    this.isUser = isUser;
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        minDate: this.establishAt,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  render() {
    this.initDateRangePicker(this.$el);
  }

  @on({ event: 'click', selector: '.input-group-append' })
  onClickAppend(event: any) {
    if (this.isUser) {
      $(event.target)
        .parents('.input-group')
        .children('input,.daterange-picker')
        .focus();
    }
  }

  @on({
    event: 'change',
    selector:
      '#company_stock_option_rightholder_form_stakeholder_attributes_employee_number',
  })
  onChangeFormControl(event: any) {
    const inputElement = $(`#${event.target.id}`);
    const convertedValue = convertToHalfWidth(inputElement.val());
    $(inputElement).val(convertedValue);
  }

  @on({
    event: 'blur input',
    selector:
      '#company_stock_option_rightholder_form_stakeholder_attributes_employee_number',
  })
  onBlurFormControl(event: any) {
    const inputElement = $(`#${event.target.id}`);
    const convertedValue = inputElement
      .val()
      .replace(
        /[ぁ-んァ-ン一-龥！!@#$%^&*()_+=､｡｢｣･【】[\]<>《》?{}|^〜･"':;*〔〕〘〙｢｣､･,.\s/＠＃＄％＾＆＊（）＿＋＝、。「」・【】［］<>《》？｛｝｜＾〜・"'：；＊〔〕〘〙「」、・，『』]/g,
        '',
      );
    $(inputElement).val(convertedValue);
  }
}

// フォームに入力された全角英数字を半角英数字に変換する
//'ー'のみ、半角に変換すると文字化けするため、個別にreplaceする
function convertToHalfWidth(value) {
  const halfWidthValue = value
    .replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    })
    .replace('ー', '-');
  return halfWidthValue;
}
